<template>
  <div>
    <loading v-show="load" text="Carregando os horarios"/>
    <div v-show="!load">
      <div class="text-right mb-3">
        <button class="btn btn-primary" @click="saveHours">Salvar</button>
      </div>
      <div class="card shadow-sm" style="min-height: 100px">
        <div class="card-body">
          <div class="table-responsive">
            <table class="table">
              <thead>
              <tr class="small">
                <th style="width: 200px">Dia</th>
                <th style="width: 200px" class="text-center">Abertura</th>
                <th style="width: 200px" class="text-center">Fechamento</th>
                <th style="width: 150px;">&nbsp;</th>
              </tr>
              </thead>
              <tbody>
              <tr :class="{'bg-light': !h.id}" v-for="(h, index) in hours">
                <td class="align-middle">
                  <select id="selectDia" class="form-control" v-model="h.day" style="min-width: 120px">
                    <option value="1">Domingo</option>
                    <option value="2">Segunda-Feira</option>
                    <option value="3">Terça-Feira</option>
                    <option value="4">Quarta-Feira</option>
                    <option value="5">Quinta-Feira</option>
                    <option value="6">Sexta-Feira</option>
                    <option value="7">Sábado</option>
                  </select>
                </td>
                <td class="text-center">
                  <input type="time" :id="'horarioInicio' + index" class="form-control" v-model="h.start_time" @change="validar(h, index)" required>
                </td>
                <td class="text-center">
                  <input type="time" :id="'horarioFim' + index" class="form-control" v-model="h.end_time" @change="validar(h, index)" required>
                </td>
                <td class="text-right align-middle text-nowrap">
                  <button type="button" class="btn btn-danger btn-sm mr-2" @click="deletarHorario(h)" style="width: 32px"><i class="fa fa-trash"></i></button>
                  <button type="button" class="btn btn-primary btn-sm" @click="cadastrarHorario(h, index)" style="width: 32px"><i class="fa fa-plus"></i></button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="mt-3 mb-4 text-center" v-if="!hours.length">
          <div class="mb-3 small">Cadastre os horários de atendimento da sua empresa</div>
          <button class="btn btn-primary" @click="cadastrarHorario(null)">Cadastrar Horário</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Loading from "@/components/loading";

  export default {
    name: "Hours",
    components: {Loading},
    data() {
      return {
        load: false,
        hours: []
      }
    },
    methods: {
      getBusinessHours() {
        this.load = true;
        this.$http.get("business/hours").then(response => {
          this.hours = response.data || [];
          this.load = false;

        }, res => {
          this.load = false;
          this.$swal(res.data.msg || 'Erro temporário');
        });
      },

      cadastrarHorario(h, index) {
        let day = h && h.day ? h.day : 1;
        const hour = {
          day: day.toString(),
          start_time: '00:00',
          end_time: '23:59'
        };

        if (this.hours.length) {
          this.hours.splice(index + 1, 0, hour);

        } else {
          this.hours.push(hour);
        }
      },

      saveHours() {
        if (!this.validarHorarios()) {
          this.$swal("O horário de encerramento não pode ser menor que o horário de abertura. Corrija os horários errados e salve novamente.");
          return;
        }

        this.load = true;
        this.$http.post("business/hours", { hours: this.hours || [] })
          .then(res => {
            this.load = false;
            this.$swal("Horários editado com sucesso.");
            this.getBusinessHours()

          }, res => {
            console.log(res);
            this.load = false;
            this.$swal(res.data.result,res.data.msg);
          });
      },

      validarHorarios() {
        let valido = true;

        this.hours.forEach(h => {
          if (h.start_time > h.end_time) {
            valido = false;
          }
        });

        return valido;
      },

      deletarHorario(h) {
        let index = this.hours.indexOf(h);
        if (index !== -1) this.hours.splice(index, 1);
      },

      validar(h, index) {
        const elFim = document.getElementById('horarioFim' + index);
        const elInicio = document.getElementById('horarioInicio' + index);

        if (h.end_time < h.start_time) {
          elFim.classList.add('border-danger');
          elInicio.classList.add('border-danger');

        } else {
          elFim.classList.remove('border-danger');
          elInicio.classList.remove('border-danger');
        }
      }
    },

    mounted() {
      this.getBusinessHours();
    },

    filters: {
      timer(t) {
        return t ? t.substring(5,-2) : '';
      }
    }
  }
</script>
